exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "sui-multi-select {\n  width: 100%;\n}\n\n/* fix incorrect display in semantic grid */\n:host >>> .selection {\n  min-width: inherit !important;\n}\n\n/* hide options extra infos when displayed in a tag */\n:host >>> sui-multi-select-label ul {\n  float: right;\n  margin: 0 10px;\n  padding: 0;\n  list-style: none;\n}\n\n:host >>> sui-multi-select-label .select-only {\n  display: none;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/select-group-multiple/select-group-multiple.component.css
// module id = 862
// module chunks = 0